import axios from "../utils/axios";

export const getTaskList = (payload) => {
    if (payload.fromTable) {
        //this serverice is used by 2 components so we need to handle it differently
        return axios.post(`/PlannedMaintenance/GetTaskList`, payload.data);
    } else {
        return axios.post(`/PlannedMaintenance/GetPagedMultipleChoices?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}`, payload.data);
    }
};

export const getPlannedMaintenanceListMultiple = (payload) => {
    return axios.post(`/PlannedMaintenance/GetPagedMultipleChoices?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}`, payload.data);
};

export const downloadExcelFile = (filter) => {
    return axios.post(`/PlannedMaintenance/ExportTasks`, filter, {
        responseType: "blob",
    });
};

export const getList = () => {
    return axios.get(`/Pool/GetList`);
};

export const getStatusList = () => {
    return axios.get(`/PlannedMaintenance/GetStatusList`);
};

export const getAreaList = () => {
    return axios.get(`/Area/GetList`);
};

export const getTechnicianList = () => {
    return axios.get(`/User/GetTechnicianList`);
};

export const getCostCenterList = () => {
    return axios.get(`/CostCenter/GetCostCenterList`);
};

export const getMaintenanceTypeList = () => {
    return axios.get(`/MaintenanceType/GetList`);
};

export const getMainListByAreaID = (areaID) => {
    return axios.get(`/Equipment/GetMainListByAreaID?areaId=${areaID}`);
};

export const getSubListById = (mainEquipmentID) => {
    return axios.get(`/Equipment/GetSubListById?equipmentId=${mainEquipmentID}`);
};

export const closeManyPlannedTasks = (payload) => {
    return axios.post(`/PlannedMaintenance/CloseMany`, payload);
}

export const getPoolByAssignedUser = () => {
    return axios.get(`/Pool/GetPoolByAssignedUser`);
};